app.service('compareView',function(cookie,loading, console, productsInComparison, compareConfig, log) {
	var $self, $addToCompareBtn, $removeBtn;
	var ticking=false, currentLeft = 0;
	var showDiff = true;
	
	function handleScroll(scrollLeftPos) {
		$('.compare-bar-products').css("transform", "translateX(" + -scrollLeftPos + "px)");
	}

	function toggleDiff() {
		$self.toggleClass('hide-diff');
		
		$(this).text(showDiff ? 'Pokaż różnice' : 'Ukryj różnice');

		showDiff = !showDiff;
	}

	function setElements(){
		$self = $("#comparison #container");
		$addToCompareBtn = $(".js-addto-compare", $self);
		$removeBtn = $(".js-remove-compare", $self);
		$productPrices = $(".products-prices", $self);
	}
	function setEvents(){
		$('body').on('click', '.js-toggle-diff', toggleDiff);

		$("#compare-view").on('scroll',function(){
			currentLeft = $(this).scrollLeft();
			if (!ticking) {
				requestAnimationFrame(function(){
					handleScroll(currentLeft);
					ticking = false;
				});
			}
			ticking = true;
		});
		$addToCompareBtn.on("click", goBack);
		$removeBtn.on('click',function(){
			productsInComparison.remove({ 
				productId: $(this).attr("data-id")
			});
			loading.redirect($(this).attr("data-href"));
		});
		$('a[href*=bhtml]',$self).click(function(){
			cookie.set('compareBack', document.location.href);
		});
	}
	function renderView() {
		if($productPrices.find('.price-old').length){
			$productPrices.addClass('has-discount');
		}
	}

	function goBack(){
		console.log('POWRÓT DO POPRZEDNIEJ STRONY');
		var url=cookie.get('refComp');
		if (url) {
			loading.redirect(url);
		} else {
			history.go(-1);
		}
	}
	function equalHeight( $elements ) {
		var maxHeight = Math.max.apply(null, $elements.map(function() {
			return $(this).height();
		}));
		$elements.height(maxHeight);
	}
	function compareBar() {
		var $productsNames = $('.product-name');
		equalHeight($productsNames);

		var $productsPrices = $('.product-prices', $compareBar);
		// usuwamy .price-before ze sklonowanego elementu do belki przed obliczeniem wysokości elementu z cenami
		$productsPrices.find('.price-before').remove();
		equalHeight($productsPrices);
	}

	function logEvent() {
		compareConfig.getData().products.forEach((product) => {
			log.recommendationsForAWS({
				productPlu: product.plu,
				eventCategory: 'Porównanie',
				eventAction: 'Widok porównania'
			});
		});
	}

	function init() { 
		setElements();
		setEvents();
		compareBar();
		renderView();
		productsInComparison.init();
		logEvent();
	}
	return {
		init:init
	};
});
